import { type AuthStateType, AuthState } from '@/shared/authentication/utils/constants';

import type { AllowEntry } from './isAuthorized';

// Permission check constants to avoid inline array allocations
export const AGENT_OR_ADMIN: readonly AllowEntry[] = ['agentOrAdmin'] as const;
export const PRODUCER_OR_ADMIN: readonly AllowEntry[] = ['producer', 'agentOrAdmin'] as const;
export const PRODUCER_OR_STAKEHOLDER: readonly AllowEntry[] = ['producerOrStakeholder'] as const;
export const ADMINS: readonly AllowEntry[] = ['admins'] as const;
export const GLOBAL_ADMIN: readonly AllowEntry[] = ['globalAdmin'] as const;

export const permissionGroups = {
  agentOrAdmin: [
    AuthState.globalAdministrator,
    AuthState.insuranceAgentAdministrator,
    AuthState.insuranceAgent
  ],
  admins: [AuthState.globalAdministrator, AuthState.insuranceAgentAdministrator],
  agent: [AuthState.insuranceAgent],
  globalAdmin: [AuthState.globalAdministrator],
  agentAdmin: [AuthState.insuranceAgentAdministrator],
  loggedIn: [
    AuthState.globalAdministrator,
    AuthState.insuranceAgentAdministrator,
    AuthState.insuranceAgent,
    AuthState.producer,
    AuthState.stakeholder,
    AuthState.expired
  ],
  producer: [AuthState.producer],
  stakeholder: [AuthState.stakeholder],
  producerOrStakeholder: [AuthState.producer, AuthState.stakeholder]
} as const satisfies Record<string, readonly AuthStateType[]>;

export type PermissionGroup = keyof typeof permissionGroups;
